"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _PaymentFinalizationPage = _interopRequireDefault(require("../../components/PaymentFinalizationPage"));
var _finalizePaymentSlice = require("../../redux/finalizePaymentSlice");
var _excluded = ["onSuccess"];
var withPaymentFinalizationHandler = function withPaymentFinalizationHandler(Component) {
  // eslint-disable-next-line react/prop-types
  return function WithPaymentFinalizationHandler(_ref) {
    var onSuccess = _ref.onSuccess,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
    var dispatch = (0, _reactRedux.useDispatch)();
    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
        return state.finalizeInitialPayment;
      }),
      error = _useSelector.error,
      shouldShowFinalizePaymentComponent = _useSelector.shouldShowFinalizePaymentComponent;
    var adyenRedirectResult = new URLSearchParams(window.location.search).get('redirectResult');
    var orderId = new URLSearchParams(window.location.search).get('orderId');
    if (adyenRedirectResult && orderId && !error) {
      dispatch((0, _finalizePaymentSlice.setShouldShowFinalizePaymentComponent)(true));
      return /*#__PURE__*/_react.default.createElement(_PaymentFinalizationPage.default, {
        onSuccess: onSuccess
      });
    }
    if (shouldShowFinalizePaymentComponent) {
      return /*#__PURE__*/_react.default.createElement(_PaymentFinalizationPage.default, {
        onSuccess: onSuccess
      });
    }
    return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
      onSuccess: onSuccess
    }, props));
  };
};
var _default = withPaymentFinalizationHandler;
exports.default = _default;